import repositoryService from '../../services/RepositoryService';
import appConfig from '../../services/AppConfigService';
import localDatabase from '../../services/LocalDatabaseService';

const PATH = appConfig.apiUrl() + '/f/ba/402882745af64dab015af64e419b0000/c/402882745af64dab015af64f87ed0002/14/ms/402882745af64dab015af64fcfa60003';

const state = {
  list: []
}

export const mutationsTypes = {
  LIST: 'module/LIST',
  PAGINATION: 'module/PAGINATION',
  UPDATE_FILTER: 'module/UPDATE_FILTER',
  UPDATE_FILTER_CURRENT_PAGE: 'module/UPDATE_FILTER_CURRENT_PAGE',
  UPDATE_FILTER_ITEMS_PER_PAGE: 'module/UPDATE_FILTER_ITEMS_PER_PAGE'
}

/* eslint-disable no-param-reassign */
const mutations = {
  [mutationsTypes.LIST] (state, payload) {
    state.list = payload
  },

  [mutationsTypes.PAGINATION] (state, payload) {
    state.pagination = payload
  },

  [mutationsTypes.UPDATE_FILTER] (state, payload) {
    state.filter = Object.assign({}, state.filter, payload)
  },

  [mutationsTypes.UPDATE_FILTER_CURRENT_PAGE] (state, payload) {
    state.filter.currentPage = payload
  },

  [mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE] (state, payload) {
    state.filter.itemsPerPage = payload
  }
}

const actions = {

  moduleSetList: ({commit}, payload) => {
    commit(mutationsTypes.LIST, payload)
  },

  moduleSetPagination: ({commit}, payload) => {
    commit(mutationsTypes.PAGINATION, payload)
  },

  moduleSetItemsPerPage({dispatch, commit}, payload) {
    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1)
    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload)
    dispatch("moduleSearch")
  },

  moduleSetPage({dispatch, commit}, payload) {
    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload)
    dispatch('moduleSearch')
  },

  moduleDoSearch({dispatch }, payload) {
    dispatch("moduleSearch", payload)
  },

  moduleSearch({dispatch}, id) {
    dispatch("showLoader");

    let url = PATH;

    repositoryService.search(url)
      .then(response => {
        dispatch('moduleSetList', response.fields)
        dispatch('hideLoader')
      })
  },

  moduleSave({}, payload) {
    return repositoryService.save(PATH, payload, true)
  },

  moduleGetInstance({}, payload) {
    return localDatabase.findById('Module_' + payload)
  }
}

const getters = {
  moduleFilter: function (state) {
    return Object.assign({}, state.filter)
  },
  moduleList: function () {
    return state.list
  },
  modulePagination: function () {
    return state.pagination
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/module/ModuleVuex.js